import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";

export default function RecruiterSuccess() {
  return (
    <div data-testid="recruiter-success-page" className="grid-bg min-h-[70vh] flex items-center">
      <div className="max-w-2xl mx-auto px-6 md:px-12 py-24 text-center">
        <div className="w-16 h-16 rounded-2xl bg-[#22C55E]/15 flex items-center justify-center mx-auto mb-6">
          <CheckCircle2 className="w-8 h-8 text-[#22C55E]" />
        </div>
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl">You're subscribed! 🎉</h1>
        <p className="mt-5 text-[#94A3B8] max-w-xl mx-auto leading-relaxed" data-testid="recruiter-success-message">
          Your WorldAIInfo Recruiter subscription is now active. You can start posting jobs from your dashboard immediately.
        </p>
        <div className="mt-8 flex items-center justify-center gap-4 flex-wrap">
          <Link to="/dashboard" data-testid="recruiter-success-dashboard"
            className="inline-flex items-center gap-2 bg-[#00F0FF] text-[#04121a] font-semibold px-6 py-3 rounded-md hover:brightness-110 transition">
            Go to Dashboard <ArrowRight className="w-4 h-4" />
          </Link>
          <Link to="/jobs" className="border border-white/15 px-6 py-3 rounded-md hover:border-[#00F0FF]/60 transition font-medium">
            View the jobs board
          </Link>
        </div>
        <p className="text-xs text-[#64748B] mt-8">
          A receipt has been emailed to you by Stripe. Manage or cancel your subscription anytime from your dashboard.
        </p>
      </div>
    </div>
  );
}
